import { css } from '@emotion/react';

export const getChatSectionContainerStyles = ({
  isEmbed,
  chatFiltersOpen,
  hideChatFilters,
  hideChatListPanel,
}: {
  isEmbed?: boolean;
  chatFiltersOpen?: boolean;
  hideChatFilters?: boolean;
  hideChatListPanel?: boolean;
}) => {
  if (!isEmbed) return css``;

  return css`
    width: ${!hideChatListPanel
      ? chatFiltersOpen
        ? 'calc(100% - 240px - 320px)'
        : !hideChatFilters
        ? 'calc(100% - 55px - 375px)'
        : 'calc(100% - 375px)'
      : '100%'};
    min-width: ${!hideChatListPanel
      ? chatFiltersOpen
        ? 'calc(100% - 240px - 320px)'
        : !hideChatFilters
        ? 'calc(100% - 55px - 375px)'
        : 'calc(100% - 375px)'
      : '100%'};
    max-width: ${!hideChatListPanel
      ? chatFiltersOpen
        ? 'calc(100% - 240px - 320px)'
        : !hideChatFilters
        ? 'calc(100% - 55px - 375px)'
        : 'calc(100% - 375px)'
      : '100%'};
  `;
};
